module.exports = __webpack_public_path__ + "static/media/logo_XOM.27ac953b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/logo_XOM.png
// module id = 200
// module chunks = 0